export default __webpack_public_path__ + "oyna_kazan_card_bg.png";